import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppLocalization } from 'src/app/modules/shared/entities/app-localization';
import { BarclaysResponse } from '../entities/barclays-request.class';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-barclays-payment-processing-legacy',
  templateUrl: './barclays-payment-processing-legacy.component.html',
  standalone: false
})
export class BarclaysPaymentProcessingLegacyComponent implements OnInit {
  appStrings: AppLocalization;
  barclaysResponseParams: BarclaysResponse;

  constructor(
    private route: ActivatedRoute,
  ) {
    this.route.queryParams.subscribe(routeParams => {
      window.close();
      const barclaysResponseParams = this.mapBarclaysResponse(routeParams);
      window.parent.postMessage(barclaysResponseParams, environment.webRoot);
    });
  }

  ngOnInit(): void {
    // This is intentional
  }

  /**
   * Maps the query parameters received from the Barclays processor to a BarclaysResponse object
   * @param responseObj object containing the mapped parameters and values received from Barclays
   */
  mapBarclaysResponse(responseObj: object) {
    const objectToMap: any = {};
    const responseKeys = Object.keys(responseObj);

    // Because the Barclays parameters have inconsistent case, convert all of them to uppercase before mapping the object
    for (const key of responseKeys) {
      objectToMap[key.toUpperCase()] = responseObj[key];
    }

    const barclaysResponse: BarclaysResponse = {
      aavCheck: objectToMap.AAVCHECK,
      acceptance: objectToMap.ACCEPTANCE,
      amount: Number(objectToMap.AMOUNT),
      brand: objectToMap.BRAND,
      cardNo: objectToMap.CARDNO,
      ccCty: objectToMap.CCCTY,
      cn: objectToMap.CN,
      comPlus: objectToMap.COMPLUS,
      currency: objectToMap.CURRENCY,
      cvcCheck: objectToMap.CVCCHECK,
      ed: objectToMap.ED,
      ip: objectToMap.IP,
      ipCty: objectToMap.IPCTY,
      ncError: objectToMap.NCERROR,
      orderId: objectToMap.ORDERID,
      payId: objectToMap.PAYID,
      pm: objectToMap.PM,
      status: Number(objectToMap.STATUS),
      subBrand: objectToMap.SUBBRAND,
      trxDate: objectToMap.TRXDATE,
      shaSign: objectToMap.SHASIGN,
    };

    return barclaysResponse;
  }
}
